import React, { useCallback, useContext } from 'react';
import './index.scss';

import useConditionalClassname from '~/theseus/hooks/useConditionalClassname';
import useScheduleSelector from './useScheduleSelector';

const SchedulerContext = React.createContext(null);

const DAYS = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];

/* eslint-disable */
const Hour = React.memo((props) => {
  const {
    day,
    hour,
    selected,
  } = props;

  const {
    beginAdding,
    beginRemoving,
    endSelecting,
    mouseDown,
    handleHourMouseOver,
  } = useContext(SchedulerContext);

  const className = useConditionalClassname(selected, 'hour', 'hour--active');

  const handleSelect = useCallback(() => {
    handleHourMouseOver(day, hour);
  }, [handleHourMouseOver, day, hour]);

  const handleMouseDown = useCallback((e) => {
    e.preventDefault();

    if (selected) {
      beginRemoving(day, hour);
    } else {
      beginAdding(day, hour);
    }
  }, [beginAdding, beginRemoving, selected, day, hour]);

  const handleMouseOver = useCallback((e) => {
    e.preventDefault();

    if (mouseDown) {
      handleSelect();
    }
  }, [handleSelect, mouseDown]);

  return (
    <div
      className={className}
      data-hour={hour}
      onMouseDown={handleMouseDown}
      onMouseOver={handleMouseOver}
      onMouseUp={endSelecting}
    />
  );
});

const Day = React.memo((props) => {
  const {
    day,
    dayIndex,
    hours,
    everyday = false,
  } = props;

  const { endSelecting } = useContext(SchedulerContext);

  const renderedHours = hours.map((selectedFlag, i) => (
    <Hour
      key={day + i}
      day={dayIndex}
      hour={i}
      selected={selectedFlag}
    />
  ));

  const className = useConditionalClassname(everyday, 'schedule__day', 'schedule__day--every');

  return (
    <div className={className} data-day={day} onMouseLeave={endSelecting}>
      { renderedHours }
    </div>
  );
});

export default function Scheduler(props) {
  const { onChange } = props;
  const hookState = useScheduleSelector((schedule) => {
    onChange(schedule);
  });

  const {
    everyday,
    schedule,
    clearSchedule,
    isEmpty,
  } = hookState;

  const renderedDays = schedule.map((hourArr, i) => (
    <Day
      key={DAYS[i]}
      day={DAYS[i]}
      dayIndex={i}
      hours={hourArr}
    />
  ));

  return (
    <SchedulerContext.Provider value={hookState}>
      <div className="schedule">
        { renderedDays }
        <Day
          key="Everyday"
          day="Every Day"
          hours={everyday}
          everyday
        />
        <button className="schedule__button" type="button" onClick={clearSchedule} disabled={isEmpty}>Clear Schedule</button>
      </div>
    </SchedulerContext.Provider>
  );
}
/* eslint-enable */
